// extracted by mini-css-extract-plugin
export default {"close":"ButtonClose_close__McJE0","outClose":"ButtonClose_outClose__t-QvF","btn":"ButtonClose_btn__0e1f8"};